import "./sessionexpiredalert.css";
import "primeicons/primeicons.css";

const SessionExpiredAlert = ({ onRelogin }: { onRelogin: () => void }) => {
  return (
    <div className="custom-dialog-overlay">
      <div className="custom-dialog">
        <h2>Session Expired</h2>
        <p>Your session has expired. Please log in again to continue.</p>
        <button className="custom-button" onClick={onRelogin}>
          <i className="pi pi-lock" aria-hidden="true"></i> Re-Login
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredAlert;
